import React from 'react';

const AplicacionesPlacaTipoMarmol = () => {
  return (
    <section className="pt-30 why-choose-style1">
      <div className="container">
        <div className="row mt-n1-9">
          {/* Imagen y texto flotante */}
          <div className="col-lg-6 mt-1-9">
            <div className="text-center position-relative">
              <img src="/assets/img/productos/muro-placa-tipo-marmol/placa-tipo-marmol-aplicaciones.jpg" alt="placa tipo marmol pvc" />
              <div className="why-choose-box d-none d-sm-block">
                <h5 className="text-white h4">Ideal para baños</h5>
                <span className="text-white opacity9">Placa Tipo Mármol Rígida de PVC</span>
              </div>
            </div>
          </div>

          {/* Contenido textual */}
          <div className="col-lg-6 mt-1-9">
            <div className="ps-xl-5">
              {/* Título */}
              <div className="mb-5">
                <span className="text-primary text-uppercase small letter-spacing-4 d-block font-weight-700 mb-2">Aplicaciones Versátiles</span>
                <h2 className="mb-0 display-5 font-weight-800">Las placas tipo mármol rígidas de PVC son ideales para transformar diversos espacios con elegancia y funcionalidad:</h2>
              </div>

              {/* Primera razón */}
              <div className="d-flex mt-1-9">
                <div className="flex-shrink-0 me-4">
                  <i className="icon-wallet display-12 text-primary"></i>
                </div>
                <div className="flex-grow-1">
                  <h4 className="h5">Recubrimientos de Muros en Oficinas y Locales Comerciales:</h4>
                  <p className="mb-0">Añade un toque moderno y profesional.</p>
                </div>
              </div>

              {/* Segunda razón */}
              <div className="d-flex mt-1-9">
                <div className="flex-shrink-0 me-4">
                  <i className="icon-recycle display-12 text-primary"></i>
                </div>
                <div className="flex-grow-1">
                  <h4 className="h5">Diseños en Salas y Comedores:</h4>
                  <p className="mb-0">Dale un aspecto de lujo y estilo a los espacios interiores.</p>
                </div>
              </div>

              {/* Tercera razón */}
              <div className="d-flex mt-1-9">
                <div className="flex-shrink-0 me-4">
                  <i className="icon-tools-2 display-12 text-primary"></i>
                </div>
                <div className="flex-grow-1">
                  <h4 className="h5">Revestimientos en Fachadas Interiores:</h4>
                  <p className="mb-0">Sorprende con acabados únicos que combinan practicidad y diseño.</p>
                </div>
              </div>

              {/* Cuarta razón */}
              <div className="d-flex mt-1-9">
                <div className="flex-shrink-0 me-4">
                  <i className="icon-tools-2 display-12 text-primary"></i>
                </div>
                <div className="flex-grow-1">
                  <h4 className="h5">Paredes de Baños y Cocinas:</h4>
                  <p className="mb-0">Crea ambientes sofisticados y resistentes a la humedad.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AplicacionesPlacaTipoMarmol;
